import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© 2025 Mi Tienda - Pre-entrega React.</p>
    </footer>
  );
};

export default Footer;